goog.provide('el8.data.vaccines');

goog.require('el8.model.base');

el8.data.vaccines = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name');
    _class.addStringProperty('description');
    _class.addStringProperty('cdcType');
    _class.addStringProperty('ndc');
    _class.addProperty('ndc_values');
    _class.addIntProperty('cvx');
    _class.addBoolean('userCreated');
    _class.addBoolean('elationCreated');

    return new el8_EntitySet({
        key: 'name',
        model: function(spec) { return new _class(spec); }
    });

})();

